module.exports = __webpack_public_path__ + "static/head-wink-058afacf5179d9868d1c91e6cf42db90.svg";